import { render, staticRenderFns } from "./Impersonate.vue?vue&type=template&id=5eca4527&"
import script from "./impersonate.js?vue&type=script&lang=js&"
export * from "./impersonate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports